/*
Dismiss a modal a couple of seconds after the form inside it submits successfully.

oilib's ajax form doesn't emit a success event -- the only event it fires is
oi.loaded.form.<id>, and that's on init, not submit -- so this hooks
addSuccessAction, the same overridable hook retail_user.js and quiz.js use.

The delay is the point: oilib writes its confirmation into .oi-form-message and
adds .is-valid to the form at the same moment, so closing immediately would take
the message away before it could be read.
*/

import * as bootstrap from "bootstrap";

// Long enough to read a one-line confirmation without stranding the visitor in a
// modal that looks finished.
const SUCCESS_CLOSE_DELAY = 2000;

/*
The retail user forms are deliberately left alone. They already own their own
success behaviour and it is more than "close this modal": the login/join forms
hide their modal and then open the onboarding or welcome modal, the password forms
swap to a confirmation modal, and quiz.js chains onto login/join again to release
the Floorplan Finder gate. Ids are the set inc/retail_user.js assigns to -- keep
the two in step if that file gains a form.
*/
const RETAIL_USER_FORM_IDS = [
    "oi-join-form",
    "oi-login-form",
    "oi-password-change-form",
    "oi-password-forgot-change-form",
    "oi-password-forgot-form",
    "oi-pref-form",
    "oi-profile-form",
];

document.querySelectorAll("form.oi-form[id]").forEach(function (formEl) {
    if (RETAIL_USER_FORM_IDS.indexOf(formEl.id) !== -1) return;

    const modalEl = formEl.closest(".modal");
    // On-page forms (the VIP block on a coming-soon community, the dashboard
    // preference forms) have no modal to close.
    if (!modalEl) return;

    window.addEventListener("oi.loaded.form." + formEl.id, function () {
        // Deferred a tick so any other module assigning addSuccessAction on this
        // same event has already run -- then the assignment below chains onto it
        // rather than dropping it, whatever order the modules happen to load in.
        setTimeout(function () {
            const form = oi.loaded.form[formEl.id];
            if (!form) return;

            let closeTimer = null;

            // Don't let a pending close fire into a modal the visitor already
            // dismissed and reopened inside the delay window.
            modalEl.addEventListener("hidden.bs.modal", function () {
                clearTimeout(closeTimer);
                closeTimer = null;
            });

            const previousAction = form.addSuccessAction;
            form.addSuccessAction = function () {
                if (typeof previousAction === "function") {
                    previousAction.apply(this, arguments);
                }
                clearTimeout(closeTimer);
                closeTimer = setTimeout(function () {
                    bootstrap.Modal.getOrCreateInstance(modalEl).hide();
                }, SUCCESS_CLOSE_DELAY);
            };
        }, 0);
    });
});
